// src/components/HomepageComponents/StepByStep.js
import React from 'react';
import { Link } from 'react-router-dom';

// replace with your assets
import img1 from '../../images/howitworks1.png';
import img2 from '../../images/howitworks2.png';
import img3 from '../../images/howitworks3.png';

const cards = [
  {
    img: img1,
    title: 'Snapshot',
    desc: 'Take a quick selfie and complete the onboarding to understand your hair loss situation.',
  },
  {
    img: img2,
    title: 'Guidance',
    desc: 'Depending on your hair loss level, medical background and budget, we will guide you towards the best options.',
  },
  {
    img: img3,
    title: 'Evaluate',
    desc: 'Our experts reach out with a full-fledged report and connect you with the best doctor for you.',
  },
];

const HowItWorks = () => (
  <section className="md:mt-12 first-letter:container mx-auto px-4 md:px-12 py-8 md:w-11/12">
    {/* Title (same format as HookSection) */}
    <h2 className="text-center text-3xl md:text-4xl font-extrabold">
      How it works
    </h2>

    {/* 3-card grid */}
    <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4">
      {cards.map(({ img, title, desc }, idx) => (
        <div
          key={title}
          className="flex flex-col items-start text-left
                     lg:bg-white lg:rounded-2xl lg:shadow-lg
                     transition-transform duration-300 lg:hover:scale-105"
        >
          <img
            src={img}
            alt={title}
            className="w-full h-auto mb-4 rounded-2xl lg:rounded-t-2xl lg:rounded-b-none"
          />

          {/* Step badge + title */}
          <div className="flex items-center mb-2 px-0 lg:px-6 border-b border-gray-300 pb-3 w-full">
            <span className="inline-block bg-gray-900 text-white rounded-full font-bold text-base lg:text-base px-3 py-1 mr-2">
              Step&nbsp;{idx + 1}
            </span>
            <h3 className="text-lg lg:text-base font-extrabold text-gray-900">
              {title}
            </h3>
          </div>

          <p className="text-gray-600 text-lg lg:text-base leading-relaxed px-0 lg:px-6 pb-6">
            {desc}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
